import { render } from "./LoginInfo.vue?vue&type=template&id=28ddcdca&scoped=true"
import script from "./LoginInfo.vue?vue&type=script&lang=ts"
export * from "./LoginInfo.vue?vue&type=script&lang=ts"

import "./LoginInfo.vue?vue&type=style&index=0&id=28ddcdca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-28ddcdca"

export default script